module.exports = __webpack_public_path__ + "static/media/kpiicon.9dc1482b.png";